module.exports = __webpack_public_path__ + "static/img/cert-auth-3.900176f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cert-auth-3.png
// module id = nJ/w
// module chunks = 1